const SURNAME_PARTICLES = new Set([
  'de',
  'del',
  'la',
  'las',
  'los',
  'da',
  'do',
  'dos',
]);

function formatClock(value) {
  if (!value) return '';
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const hours = String(value.getHours()).padStart(2, '0');
    const minutes = String(value.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }
  const match = String(value).trim().match(/^(\d{1,2}):(\d{2})/);
  if (!match) return '';
  return `${match[1].padStart(2, '0')}:${match[2]}`;
}

function mechanicSurname(fullName) {
  const name = String(fullName || '').trim();
  if (!name) return '';
  const commaIdx = name.indexOf(',');
  if (commaIdx !== -1) return name.slice(0, commaIdx).trim();
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length <= 1) return parts[0] || '';
  let start = parts.length - 1;
  while (start > 0 && SURNAME_PARTICLES.has(parts[start - 1].toLowerCase())) {
    start -= 1;
  }
  return parts.slice(start).join(' ');
}

function isMaintenanceAppointment(appointment) {
  const typeName = String(appointment?.serviceType?.name || '');
  return (
    Number(appointment?.serviceTypeId) === 1 ||
    /mantenimiento/i.test(typeName)
  );
}

function formatServiceLine(appointment) {
  const typeName = String(appointment?.serviceType?.name || '').trim();
  const serviceName = String(appointment?.service?.name || '').trim();
  if (isMaintenanceAppointment(appointment)) {
    return serviceName || typeName;
  }
  return typeName || serviceName;
}

export function getAppointmentDescriptionLabel(appointment) {
  const plate = String(appointment?.vehicle?.plate || '').trim();
  const label =
    appointment?.description ||
    appointment?.service?.name ||
    appointment?.serviceType?.name ||
    'Servicio';

  return plate ? `${plate} · ${label}` : label;
}

export function getCalendarCardLines(appointment, range) {
  const start = formatClock(appointment?.time) || formatClock(range?.start);
  const end = formatClock(range?.end);
  const horario = start && end && start !== end ? `${start}–${end}` : start;

  const plate = String(appointment?.vehicle?.plate || '').trim();
  const customer = String(appointment?.customer?.name || '').trim();
  const model = String(
    appointment?.vehicle?.model?.description || appointment?.vehicle?.brand || '',
  ).trim();
  const service = formatServiceLine(appointment);
  const mechanic =
    mechanicSurname(appointment?.mechanic?.name || appointment?.mechanicName) ||
    'Sin operario';
  const status = String(appointment?.status || '').trim();

  return [horario, plate, customer, model, service, mechanic, status].filter(Boolean);
}

export function formatSchedulerCalendarTitle(appointment, range) {
  return getCalendarCardLines(appointment, range).join('\n');
}

export function formatAvailableTimesEventTitle(appointment) {
  const mechanicName =
    appointment?.mechanic?.name ||
    appointment?.mechanicName ||
    'Sin mecánico';
  const description = getAppointmentDescriptionLabel(appointment);
  return `${mechanicName} - ${description}`;
}
